module.exports = __webpack_public_path__ + "img/hr-water-outer-corner.8aede59d.png";